module.exports = __webpack_public_path__ + "images/backgrounds/pdf-balloon-6ce88312634f5005822bad18cc83ed18.webp";